import { initSentry } from '@/lib/monitoring/sentry'
initSentry()

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import './index.css'
import { initializeTheme } from '@/lib/theme'

// Apply theme before first paint to prevent light-mode flash
initializeTheme()

// Register service worker for PWA support (offline caching + push notifications)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Silent fail — SW registration is not critical for app function
    })
  })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
